<template>
  <div
    class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border transition-colors cursor-pointer relative group"
    :class="statusClasses"
  >
    <span class="truncate max-w-[100px]">{{ displayStatus }}</span>

    <!-- Note indicator -->
    <MessageCircleMore v-if="hasNotes" class="w-3 h-3 opacity-70" />

  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { MessageCircleMore } from 'lucide-vue-next'

const props = defineProps<{
  status: string
  hasNotes?: boolean
}>()

const displayStatus = computed(() => {
  if (!props.status) return 'Pending'
  return props.status
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
})

const statusClasses = computed(() => {
  const status = props.status?.toLowerCase() || ''

  if (['passed', 'completed', 'hired', 'offer_accepted'].some((s) => status.includes(s))) {
    return 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-200 hover:border-emerald-300'
  }
  if (['failed', 'rejected', 'dropped_out'].some((s) => status.includes(s))) {
    return 'bg-red-50 text-red-700 border-red-200 hover:bg-red-200 hover:border-red-300'
  }
  if (['in_progress', 'scheduled', 'interviewing'].some((s) => status.includes(s))) {
    return 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-200 hover:border-blue-300'
  }
  if (['skipped', 'exempt'].some((s) => status.includes(s))) {
    return 'bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-200 hover:border-gray-300'
  }

  return 'bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-200 hover:border-gray-300'
})
</script>
